import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { createProviderFailed, createProviderSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* createProvider(action) {
  try {
    const url = `${BACKEND_URL}/providers`;
    const pool = action.payload;
    const response = yield makeRequest(url, pool, action, 'POST', true);
    if (response.status === OK) {
      const data = yield getBodyJson(response);
      yield put(createProviderSuccessful());
      yield call(resolveActionPromise(action, data));
    } else {
      const data = yield getBodyJson(response);
      yield put(createProviderFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createProviderFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
